import { postP,get,getJ,put,deleteP,getExcel,uploadOther,uploadOtherSort,upload,postPackage,getPDF  } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    
    // 获取后台用户菜单权限
    // GetUserMenu(datas){
    //     return get('AUser/GetUserMenu',datas)
    // },
    // 创建后台用户
    CreateUser(datas){
        return postP('Admin/CreateUser',datas)
    },
    // 修改后台用户
    UpdateUser(datas){
        return postP('Admin/UpdateUser',datas)
    },
    // 查询后台用户
    QueryUsers(datas){
        return get('Admin/QuryUsers',datas)
    },

    // 创建公估师
    CreateAssessor(datas){
        return postP('Admin/CreateAssessor',datas)
    },
    // 修改公估师
    UpdateAssessor(datas){
        return postP('Admin/UpdateAssessor',datas)
    },
    // 查询公估师
    QueryAssessor(datas){
        return get('Admin/QueryAssessor',datas)
    },
    // 查询公估师详情
    QueryAssessorById(datas){
        return get('Admin/QuryAssessorById',datas)
    },

    // 获取角色列表
    QueryRole(datas){
        return get('Admin/QueryRole',datas)
    },
    // 更新角色
    UpdateRole(datas){
        return postP('Admin/UpdateRole',datas)
    },
    // 删除角色
    DeleteRole(datas){
        return deleteP('Admin/DeleteRole',datas)
    },
    // 创建后台用户角色
    CreateRole(datas){
        return postP('Admin/CreateRole',datas)
    },

    // 创建作业机构
    CreateMechanism(datas){
        return postP('Admin/CreateMechanism',datas)
    },
    // 修改作业机构
    UpdateMechanism(datas){
        return postP('Admin/UpdateMechanism',datas)
    },
    // 作业机构列表
    QueryMechanism(datas){
        return get('Admin/QueryMechanism',datas)
    },
    // 作业机构详情
    QuryMechanismById(datas){
        return get('Admin/QuryMechanismById',datas)
    },




    //获取后台用户权限iD
    GetUserPermissionId(datas){
        return getJ('AUser/GetUserPermissionId/',datas)
    },
    //创建权限许可
    createAsyncP(datas){
        return postP('Permission/CreateAsync',datas)
    },

    //创建后台资源
    createResource(datas){
        return postP('Admin/CreateResource',datas)
    },
    //删除资源
    deleteResource(datas){
        return deleteP('Admin/DeleteResource',datas)
    },
    //获取所有菜单资源
    queryResource(datas){
        return get('Admin/QueryResource',datas)
    },
    //修改权限
    updateResource(datas){
        return postP('Admin/UpdateResource',datas)
    },
    // 查看用户的权限列表
    queryPermission(datas){
        return get('Admin/QueryPermission/'+datas)
    },
    // 查询权限列表菜单和操作权限
    queryPermissionMenuOperation(datas){
        return get('Admin/QueryPermissionMenuOperation/'+datas)
    },
    // 修改权限
    updatePermission(datas){
        return postP('Admin/UpdatePermission',datas)
    },

    // 更新案件费用
    updateAssetsFee(datas){
        return put('Assets/UpdateAssetsFee',datas)
    },
    updateAssetsYuGuFee(datas){
        return put('Assets/UpdateAssetsYuGuFee',datas)
    },
    updateAssetsJSFee(datas){
        return put('Assets/UpdateAssetsJSFee',datas)
    },
    // 删除案件
    deleteAsset(datas){
        return deleteP('Assets/DeleteAsync',datas)
    },

   // 再次推送
    anXinDcTaskSendDcTaskAction(datas){
        return get('Assets/SendCwDcTask/'+datas)
    },
        // 取消委托案件
        CancelAsset(datas){
            return postP('Assets/CancelAsync',datas)
        },
    //查询资产评估列表
    QueryAssets(datas){
        return get('Assets/QueryAssetsType',datas)
    },
    //查询资产评估物损详情
    QueryAssetsMaterialDamage(datas){
        return get('Assets/QueryAssetsMaterialDamage/'+datas)
    },
    //查询资产评估车损详情
    QueryAssetsCarDamage(datas){
        return get('Assets/QueryAssetsCarDamage/'+datas)
    },
    //查询资产评估车损详情
    QueryAssetsCommonCarDamage(datas){
        return get('Assets/QueryAssetsCommonCarDamage/'+datas)
    },
    // 更新案件流转状态
    UpdateAssetsState(datas){
        return put('Assets/UpdateAssetsState',datas)
    },
    // 更新案件审核状态
    UpdateAssetsAuditState(datas){
        return put('Assets/UpdateAssetsAuditState',datas)
    },


////天合富家接口

    notifySupplement(datas){
        return postP('Assets/notifySupplement',datas)
    },
    pushStatus(datas){
        return postP('Assets/pushStatus',datas)
    },
    pushReports(datas){
        return postP('Assets/pushReport',datas)
    },


    // 更新资产评估物损
    UpdateAssetsMaterialDamage(datas){
        return put('Assets/UpdateAssetsMaterialDamage',datas)
    },
    // 更新资产评估车损
    UpdateAssetsCarDamage(datas){
        return put('Assets/UpdateAssetsCarDamage',datas)
    },
    // 更新资产评估共同委托车损
    UpdateAssetsCommonCarDamage(datas){
        return put('Assets/UpdateAssetsCommonCarDamage',datas)
    },

    
    // 回款操作
    UpdateAssetsIsPayment(datas){
        return put('Assets/UpdateAssetsIsPayment',datas)
    },

    // 创建资产评估物损
    createAssetsMaterialDamage(datas){
        return postP('Assets/CreateAssetsMaterialDamageAsync',datas)
    },
    createAssetsCarDamage(datas){
        return postP('Assets/CreateAssetsCarDamageAsync',datas)
    },
    createAssetsCommonCarDamage(datas){
        return postP('Assets/CreateAssetsCommonCarDamageAsync',datas)
    },

    // 生成定损url
    generateLossUrl(datas){
        return postP('Assets/GenerateLossUrl',datas)
    },
    queryGenerateLoss(datas){
        return postP('Assets/QueryGenerateLoss',datas)
    },
    downLoadFile(datas){
        return postPackage('Common/DownLoadFile',datas)
    },

    // 调度员查询
    dispatcherQueryAssets(datas){
        return get('Assets/DispatcherQueryAssets',datas)
    },
    // 分机构查询
    mechanismQueryAssets(datas){
        
        if(store.getters['global/s_role'].roleName == '机构管理员'){
            return get('Assets/MechanismQueryAssets',datas)
        }else{
            return get('Assets/OperatorQueryAssets',datas)
        }  
    },
    // 作业人员查询
    operatorQueryAssets(datas){
        return get('Assets/OperatorQueryAssets',datas)
    },

    // 案件列表
    queryAssetsType(datas){
        return get('Assets/QueryAssetsType',datas)
    },

    // 通过角色Id查询角色名称
    queryRoleName(datas){
        return get('Admin/QueryRoleName',datas)
    },

    // 创建车险调查
    createAssetsCarInsuranceAsync(datas){
        return postP('Assets/CreateAssetsCarInsuranceAsync',datas)
    },
    // 创建财产险
    createAssetsPropertyInsuranceAsync(datas){
        return postP('Assets/CreateAssetsPropertyInsuranceAsync',datas)
    },
    // 查询车险调查详情
    queryAssetsCarInsuranceResponse(datas){
        return get('Assets/QueryAssetsCarInsuranceResponse/'+datas)
    },
    // 查询财产险详情
    queryAssetsPropertyInsuranceResponse(datas){
        return get('Assets/QueryAssetsPropertyInsuranceResponse/'+datas)
    },
    // 更新车险调查
    updateAssetsCarInsurance(datas){
        return put('Assets/UpdateAssetsCarInsurance/',datas)
    },
    // 更新财产险
    updateAssetsPropertyInsurance(datas){
        return put('Assets/UpdateAssetsPropertyInsurance/',datas)
    },
    // 创建保险公司
    createBxCompany(datas){
        return postP('Admin/CreateBxCompany',datas)
    },
    // 更新保险公司
    updateBxCompany(datas){
        return put('Admin/UpdateBxCompany',datas)
    },
    // 查询保险公司分页
    queryPagerListBxCompnay(datas){
        return get('Admin/QueryPagerListBxCompnay',datas)
    },
    // 查询保险公司
    queryBxCompnay(datas){
        return get('Admin/QueryBxCompnay',datas)
    },

    // 下载评估pdf
    getPDFCarBad(datas,name){
        return getPDF('CarBad',datas,name)
    },
    //  下载车险调查pdf
    queryReport(datas,name){
        return getPDF('QueryReport',datas,name)
    },
    //  下载财产险
    downLoadAsset(datas,name){
        return getPDF('DownLoad',datas,name)
    },

    //  下载评估pdf  最新
    getPDFCarBadBodyLoss(datas,name){
        return getPDF('BodyLoss',datas,name)
    },
    // 删除作业机构
    deleteMechanism(datas){
        return deleteP('Admin/DeleteMechanism',datas)
    },

    // 推送财务
    publishCaiWu(datas){
        return get('Assets/PublishCaiWu/'+datas)
    },

    // 修改密码
    updatePassword(datas){
        return postP('Admin/updatePWD',datas)
    },

    businessAcceptanceDay(datas){
        return get('DataCenter/BusinessAcceptanceDay',datas)
    },
    anJianTongJi(datas){
        return get('DataCenter/AnJianTongJi',datas)
    },
    queryPagerCaseTrack(datas){
        return get('DataCenter/QueryPagerCaseTrack',datas)
    },
    uploadReport(file,params){
        return upload('WordToPDF',file,params)
    },
    
    // 添加案件
    addJudicial(datas){
        return postP('Judicial/AddJudicial',datas)
    },
    // 更新案件
    updateJudicial(datas){
        return put('Judicial/UpdateJudicial',datas)
    },
    // 添加案件文书
    addJudicialDoc(datas){
        return postP('Judicial/AddJudicialDoc',datas)
    },
    // 添加案件材料
    addJudicialMaterial(datas){
        return postP('Judicial/AddJudicialMaterial',datas)
    },
    // 审核案件
    examineState(datas){
        return postP('Judicial/ExamineState',datas)
    },
    // 案件鉴定
    judicialState(datas){
        return postP('Judicial/State',datas)
    },
    // 查询案件列表
    judicialQueryJudicial(datas){
        return get('Judicial​/QueryJudicial',datas)
    },
    // 查询案件文书列表
    judicialQueryJudicialDoc(datas){
        return get('Judicial​/QueryJudicialDoc/'+datas)
    },
    // 查询案件材料列表
    judicialQueryJudicialMaterial(datas){
        return get('Judicial​/QueryJudicialMaterial/'+datas)
    },
    // 查询案件操作日志
    judicialQueryJudicialLog(datas){
        return get('Judicial​/QueryJudicialLog/'+datas)
    },
    // // 主体委托
    // evaluationSection(datas){
    //     return get('DataCenter/EvaluationSection',datas)
    // },
    // 评估日报表
    evaluationSection(datas){
        return get('DataCenter/EvaluationSection',datas)
    },
    // 主体日报表
    surveySection(datas){
        return get('DataCenter/SurveySection',datas)
    },

    queryFilesList(datas){
        return get('Admin/QueryFilesList',datas)
    },

    addZcpgFiles(datas){
        return postP('Admin/AddZcpgFiles',datas)
    },
    updateZcpgFiles(datas){
        return postP('Admin/UpdateFiles',datas)
    },
    deleteZcpgFiles(datas){
        return postP('Admin/DeleteFiles?id='+datas)
    },
    

    // 导出数据
    export(datas,name){
        return getExcel('Common/Export',datas,name)
    },
    uploadOther(file,params,name){
        console.log(file);
        return uploadOther('',file,params,name)
    },
    uploadOtherSort(file,params,name){
        return uploadOtherSort('',file,params,name)
    },
    upload(file,params){
        return upload('Common/UploadFile',file,params)
    },
}